//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Illustration, Typography } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { searchPaymentAdvertising } from '@payment'

export default {
  components: {
    Illustration,
    Typography,
  },
  computed: {
    ...mapGetters({
      paymentMethods: 'countryConfig/paymentMethods',
    }),

    advertising() {
      return searchPaymentAdvertising(this.paymentMethods)
    },
  },
}
